import { FC } from 'react';
import { Select, SelectProps } from '@app/form_components';
import { useAsync, useDesign, useServices } from '@app/hooks';
import {
  AudioType,
  LanguageCode,
  TextToSpeechVoice,
  Voice
} from '@app/types';

type Value = TextToSpeechVoice | Voice;

type VoiceDropdownProps = (
  Omit<SelectProps<Value>, 'options'>
  & {
    audioType: AudioType;
    languageCode: LanguageCode;
  }
);

export const VoiceDropdown: FC<VoiceDropdownProps> = ({
  audioType,
  languageCode,
  ...baseProps
}) => {
  const serialized = useDesign();
  const voiceKey = (audioType === AudioType.tts) ? 'ttsFallBackVoice' : 'voice';
  const { workflowService } = useServices();
  const [wfsVoices, isLoading] = useAsync(() => {
    return workflowService.getVoices(audioType);
  }, [audioType]);
  const voiceLabels = new Map(wfsVoices?.map(({ label, value }) => [value, label]));

  const voices = (
    serialized.languages.filter((language) =>
      !!language[voiceKey]
      && (!languageCode || language.language === languageCode)
    ).map((language) => {
      const code = language[voiceKey] as Value;
      return {
        label: voiceLabels.get(code) ?? code,
        value: code
      };
    })
  );

  return (
    <Select<Value>
      options={(isLoading) ? [] : voices}
      {...baseProps}
    />
  );
};
